export const getUrlParams = function(router) {
  const params = new URLSearchParams(router.location.search)
  const data = {}
  for (var v of params.entries()) {
    data[v[0]] = v[1]
  }
  return data
}
